import React from 'react';
import { Heart, Users, Award, Shield } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

export const About = () => {
  const valueIcons = [
    { icon: Heart, color: 'from-red-400 to-pink-400' },
    { icon: Users, color: 'from-blue-400 to-indigo-400' },
    { icon: Award, color: 'from-yellow-400 to-amber-400' },
    { icon: Shield, color: 'from-green-400 to-emerald-400' }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-amber-50/30">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-400 to-orange-400 rounded-3xl blur-2xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src={mockData.about.image}
                alt="Sobre o Recanto Abelhinha"
                className="w-full h-[500px] object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/40 to-transparent"></div>
              
              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-xl">
                <div className="text-3xl font-bold text-amber-600">{mockData.school.yearsOfExperience}</div>
                <div className="text-sm text-gray-600">Anos de História</div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-yellow-300 rounded-full blur-3xl opacity-40 animate-pulse"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-orange-300 rounded-full blur-3xl opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block mb-4">
              <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
                Nossa História
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
              Transformando Vidas desde {mockData.school.since}
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              {mockData.about.description}
            </p>

            {/* Mission Box */}
            <Card className="bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200 mb-8 shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="bg-gradient-to-br from-amber-400 to-orange-400 p-3 rounded-xl flex-shrink-0">
                    <Heart className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-2 text-lg">Nossa Missão</h3>
                    <p className="text-gray-700 leading-relaxed">{mockData.about.mission}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Values Grid */}
            <div>
              <h3 className="font-bold text-gray-800 mb-4 text-xl">Nossos Valores</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100">
                  <div className="bg-gradient-to-br from-red-400 to-pink-400 p-2 rounded-lg flex-shrink-0">
                    <Heart className="text-white" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">{mockData.about.values[0]}</span>
                </div>
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100">
                  <div className="bg-gradient-to-br from-blue-400 to-indigo-400 p-2 rounded-lg flex-shrink-0">
                    <Users className="text-white" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">{mockData.about.values[1]}</span>
                </div>
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100">
                  <div className="bg-gradient-to-br from-yellow-400 to-amber-400 p-2 rounded-lg flex-shrink-0">
                    <Award className="text-white" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">{mockData.about.values[2]}</span>
                </div>
                <div className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100">
                  <div className="bg-gradient-to-br from-green-400 to-emerald-400 p-2 rounded-lg flex-shrink-0">
                    <Shield className="text-white" size={20} />
                  </div>
                  <span className="text-gray-700 font-medium">{mockData.about.values[3]}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
